<template>
  <div class>

    <sweet-modal ref="modal" width="900px" hide-close-button blocking>



       <p class="popup-save-title">{{ this.$t('ct-title-connected-domain-popup') }}</p>
       <p class="popup-save-message">
         {{ this.$t('ct-message-connected-domain-popup') }}
        </p>

        <div class="button-container">
          <div class="loading-gif">
              <img src="https://i.gifer.com/TqwF.gif" style="height: 100%" alt="">
          </div>
        </div>

      <button slot="button" class="btn btn-outline-light mt-2 btn-publish" :class="{ 'btn-disabled': disabled }">{{ this.$t('ct-title-connected-domain-popup-auto') }} {{ timeLeft }} s </button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import axios from 'axios';
export default {
  props: ['show'],
  name: 'ModalDomainConnected',
  components: {
    SweetModal
  },
  data() {
    return {
      myInterval : '',
      timeLeft: 10,
      disabled: 1
    };
  },
  watch: {
    show: function(value) {
      if (value){
        this.timeLeft = 10;
        this.$refs.modal.open();
         this.countDown();
      }else
      this.$refs.modal.close();
    }
  },
  methods: {

    close(){
       clearInterval(this.myInterval);
        this.$emit('closeAction');
    },

    countDown() {
        var vm = this;

      this.myInterval = setInterval(function() {
        if (vm.timeLeft == 0){
              clearInterval(vm.myInterval);
              vm.$emit('closeAction');
        }else{
          vm.timeLeft = parseInt(vm.timeLeft) - 1;
        }
      }, 1000);
    },


  },
  mounted(){

  }

};
</script>

<style lang="scss" scoped>




</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalDomainConnected.vue